import React from 'react';
import { withRouter } from 'next/router';
import { graphql, compose } from 'react-apollo';
import PropTypes from 'prop-types';

import { Modal, Title } from '../ui';
import { ModalClose, ModalContent } from '../ui/Modal';
import { ButtonBrand } from '../ui/Button';
import { SessionModalButtonWrapper, SessionModalRichText } from './SessionModal.style';

import { dictionaryItem } from '../../hocs/withDictionary';
import { navigateTo } from '../../lib/helpers/navigation';

import GET_CONFIGURATION from '../../config/graphql/getConfiguration';
import IbePropTypes from '../../IbePropTypes';
import { authenticationErrors } from '../../server/constants';

const SessionModal = ({
  active, configuration, router, toggleModal,
}) => {
  const onLoginClick = (e) => {
    const { query } = router;
    const { loginUrlLink } = configuration;
    const returnUrl = encodeURIComponent(query.ReturnUrl);
    const url = `${loginUrlLink}?ReturnUrl=${returnUrl}&UseReturnURL=true`;
    navigateTo(url);
  };

  const wasFailedLogin = router.query.authenticationError === authenticationErrors.LOGIN_FAILED;

  return (
    <Modal active={active} onClickOutside={toggleModal} overlay>
      <ModalContent>
        <ModalClose onClick={toggleModal} />
        <Title
          size={1}
          dictionary={dictionaryItem('SessionModal', wasFailedLogin ? 'FailedLogin' : 'TokenExpired')}
          marginBottom="2rem"
        />
        <SessionModalRichText
          dictionary={dictionaryItem('SessionModal', wasFailedLogin ? 'FailedLogin' : 'TokenExpired')}
        />
        <SessionModalButtonWrapper>
          <ButtonBrand
            onClick={wasFailedLogin ? onLoginClick : toggleModal}
            dictionary={dictionaryItem('SessionModal', wasFailedLogin ? 'FailedLogin' : 'TokenExpired')}
          />
        </SessionModalButtonWrapper>
      </ModalContent>
    </Modal>
  );
};

SessionModal.propTypes = {
  active: PropTypes.bool,
  toggleModal: PropTypes.func,
  router: PropTypes.shape(IbePropTypes.router),
  configuration: PropTypes.shape(IbePropTypes.configuration).isRequired,
};

SessionModal.defaultProps = {
  active: false,
  toggleModal: () => {},
  router: {},
};

export default compose(
  withRouter,
  graphql(GET_CONFIGURATION, {
    props: ({ data }) => ({
      configuration: data.configuration,
      loading: data.loading,
    }),
  }),
)(SessionModal);
